import React from 'react';
import { Map } from 'immutable';
import { EditableCellTypes } from 'flux/stores/cuesheet/CuesheetConstants';
import CuesheetCellActions from 'flux/actions/cuesheet/CuesheetCellActions';
import classNames from 'classnames';
import EditableRTECell from 'main/components/show/cuesheet/editableRTECell.jsx';
import CellHistoryIcon from 'main/components/show/cuesheet/cellHistoryIcon.jsx';
import FDTPropUpdateFixMixin from 'main/components/show/cuesheet/FDTPropUpdateFixMixin';
import HighlightCellMixin from 'main/components/show/cuesheet/highlightCellMixin';
import { appendTextToRTEState } from 'shared/lib/rteHelper';
import HighlightCellHelper from 'main/components/show/cuesheet/highlightCellHelper';

/**
 * Description editable cell
 *
 */
export default React.createClass({
  displayName: 'ItemDescriptionCell',

  mixins: [FDTPropUpdateFixMixin, HighlightCellMixin],

  propTypes: {
    item: React.PropTypes.any.isRequired,
    isEditing: React.PropTypes.bool,
    isSelected: React.PropTypes.bool,
    isCopied: React.PropTypes.bool,
    rowIndex: React.PropTypes.number.isRequired,
    placeholder: React.PropTypes.string,
  },

  getDefaultProps() {
    return {
      isEditing: false,
      isSelected: false,
      placeholder: '',
    };
  },

  render() {
    const {
      isSelected,
      isEditing,
      isCopied,
      placeholder,
      item,
      partialCell,
      rowIndex,
      isTracked,
      descriptionCollabCell,
    } = this.props;

    let historyNode = null;

    let rteState = this._getCellState();

    if (rteState && !isEditing) {
      if (!item.get('description')) {
        //Just checking the blocks for text doesn't test whether there is no text but an entity (image, etc)
        rteState = appendTextToRTEState(rteState, placeholder);
      }
    }

    const cellSpec = Map({
      type: EditableCellTypes.ItemDescription,
      value: EditableCellTypes.ItemDescription,
    });

    if (isSelected && !isEditing) {
      historyNode = (
        <CellHistoryIcon
          onClick={() =>
            CuesheetCellActions.showCellHistory(rowIndex, cellSpec)
          }
        />
      );
    }

    const className = classNames('cs-desc-cell', {
      'cs-cell-copied': isCopied,
    });

    const globalHighlightStyle = isTracked
      ? {}
      : this.getGlobalHighlightStyle();
    const collabStyle = HighlightCellHelper.getCollabBorderStyle(
      descriptionCollabCell,
    );

    let format = item.get('descriptionFormat');

    //Don't use backColor formatting on the cell if we're tracking
    if (isTracked && format) {
      format = format.delete('backColor');
    }

    return (
      <div>
        {historyNode}
        <EditableRTECell
          style={Object.assign({}, globalHighlightStyle, collabStyle)}
          format={format}
          onSelect={this._select}
          onStartEdit={this._startEditing}
          onStopEdit={this._stopEditing}
          rteState={rteState}
          resizeWhenEditing
          extraClassName={className}
          allowMarkdown
          partialCell={partialCell}
          collabCell={descriptionCollabCell}
          {...this.props}
        />
      </div>
    );
  },

  _getCellState() {
    return this.props.item.get('rteDescriptionState');
  },

  _select() {
    CuesheetCellActions.selectItemCell(
      this.props.rowIndex,
      EditableCellTypes.ItemDescription,
    );
  },

  _startEditing() {
    CuesheetCellActions.startEditingItemCell(
      this.props.rowIndex,
      EditableCellTypes.ItemDescription,
    );
  },

  _stopEditing(rteState, rowId) {
    const cellSpec = Map({
      type: EditableCellTypes.ItemDescription,
      value: EditableCellTypes.ItemDescription,
    });

    CuesheetCellActions.saveDataCellChanges(rowId, cellSpec, rteState);
  },
});
